import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import apiClient from '../api/client';
import Header from '../components/Header';
import { BuilderSectionsView } from '../components/HomePageBuilderView';
import { useLanguage } from '../context/LanguageContext';
import './PageView.css';
import '../components/HomePageBuilderView.css';

function PageView() {
  const { slug } = useParams();
  const { language, t } = useLanguage();

  const { data: page, isLoading } = useQuery({
    queryKey: [`page-${slug}`, language],
    queryFn: async () => {
      const res = await apiClient.get(`/pages/${slug}`, { params: { lang: language || 'lt' } });
      return res.data;
    },
    enabled: !!slug,
  });

  const getTitle = () => {
    if (!page) return '';
    switch (language) {
      case 'en': return page.title_en || page.title_lt;
      case 'de': return page.title_de || page.title_lt;
      default: return page.title_lt;
    }
  };

  const getContent = () => {
    if (!page) return '';
    switch (language) {
      case 'en': return page.content_en || page.content_lt;
      case 'de': return page.content_de || page.content_lt;
      default: return page.content_lt;
    }
  };

  if (isLoading) {
    return (
      <div>
        <Header />
        <div className="page-view-container">
          <div className="container">{t('loading')}</div>
        </div>
      </div>
    );
  }

  if (!page) {
    return (
      <div>
        <Header />
        <div className="page-view-container">
          <div className="container">
            <h1>{t('pageNotFound')}</h1>
            <p>{t('checkUrl')}</p>
          </div>
        </div>
      </div>
    );
  }

  const hasBuilderContent = page.content?.sections && Array.isArray(page.content.sections) && page.content.sections.length > 0;

  return (
    <div>
      <Header />
      <main className="page-view-container" role="main" aria-labelledby="page-title">
        <div className="container">
          <article className="page-content">
            {hasBuilderContent ? (
              <>
                <h1 id="page-title" className="page-content-title">{getTitle()}</h1>
                <BuilderSectionsView sections={page.content.sections} />
              </>
            ) : (
              <>
                <h1 id="page-title">{getTitle()}</h1>
                <div
                  className="page-body"
                  dangerouslySetInnerHTML={{ __html: getContent() }}
                  aria-label={t('pageContent')}
                />
              </>
            )}
          </article>
        </div>
      </main>
    </div>
  );
}

export default PageView;
